import React from "react";
import "./index.css";

const Footer = () => <footer>This is the footer</footer>;

export default Footer;
